import {isEmpty, isNil} from 'ramda';

import {DrillDownLevelName, DrillDownStatistics} from '@dms/api/core';

import {Nullish} from 'shared/web';

export function isRowSelected(
  data: DrillDownStatistics,
  selectedRow: Partial<Record<DrillDownLevelName, string | Nullish>> | Nullish
) {
  if (isNil(selectedRow) || isEmpty(selectedRow)) {
    return false;
  }

  return !data.levels.some((item) => item.value !== selectedRow[item.name]);
}
